import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Bin: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M10.6922 17.3874H10.7471C10.8528 17.38 10.9562 17.3509 11.0512 17.3016C11.1462 17.2523 11.231 17.1839 11.3009 17.1001C11.3707 17.0164 11.4241 16.919 11.4581 16.8136C11.4921 16.7082 11.506 16.5967 11.499 16.4857L11.1763 11.6009C11.1622 11.3762 11.0636 11.1665 10.9023 11.0181C10.7411 10.8696 10.5303 10.7946 10.3163 10.8094C10.1023 10.8242 9.90275 10.9277 9.76144 11.0972C9.62013 11.2666 9.54868 11.488 9.5628 11.7128L9.88549 16.5975C9.90016 16.8119 9.9915 17.0124 10.1411 17.159C10.2908 17.3055 10.4877 17.3871 10.6922 17.3874Z"
        fill="black"
      />
      <path
        d="M14.2571 17.1576C14.1079 17.3049 13.9109 17.3871 13.7062 17.3875L13.6481 17.3841C13.5423 17.3768 13.439 17.3477 13.344 17.2984C13.249 17.2491 13.1641 17.1806 13.0943 17.0969C13.0245 17.0132 12.9711 16.9158 12.9371 16.8104C12.9031 16.7049 12.8892 16.5935 12.8962 16.4824L13.2189 11.5977C13.233 11.3729 13.3316 11.1632 13.4928 11.0148C13.6541 10.8664 13.8649 10.7913 14.0789 10.8061C14.2928 10.821 14.4924 10.9245 14.6337 11.0939C14.775 11.2633 14.8465 11.4848 14.8324 11.7095L14.5097 16.5943C14.4966 16.8089 14.4063 17.0103 14.2571 17.1576Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4178 5.6654C16.2574 4.78407 15.8489 3.96606 15.2362 3.32247C14.4307 2.47633 13.3383 2.00098 12.1991 2.00098C11.06 2.00098 9.96754 2.47633 9.16205 3.32247C8.54938 3.96606 8.14092 4.78407 7.98047 5.6654H4.00596C3.792 5.6654 3.5868 5.75468 3.43551 5.91361C3.28421 6.07254 3.19922 6.2881 3.19922 6.51286C3.19922 6.73762 3.28421 6.95317 3.43551 7.1121C3.5868 7.27103 3.792 7.36032 4.00596 7.36032H5.59119L6.51332 18.8891C6.58538 19.7339 6.95398 20.5204 7.54742 21.0955C8.14087 21.6707 8.91674 21.9934 9.72415 22.001H14.6775C15.4877 21.9976 16.2676 21.6768 16.8644 21.1012C17.4613 20.5256 17.8322 19.7368 17.9045 18.8891L18.8206 7.36032H20.3925C20.6064 7.36032 20.8116 7.27103 20.9629 7.1121C21.1142 6.95317 21.1992 6.73762 21.1992 6.51286C21.1992 6.2881 21.1142 6.07254 20.9629 5.91361C20.8116 5.75468 20.6064 5.6654 20.3925 5.6654H16.4178ZM9.64261 5.6654H14.7472C14.6158 5.24173 14.3905 4.85238 14.0852 4.53164C13.5842 4.00544 12.9075 3.70555 12.1991 3.69589C11.4882 3.69679 10.8066 3.99386 10.3039 4.52195C9.99654 4.84483 9.77138 5.23794 9.64261 5.6654ZM8.11067 18.7467L7.21485 7.36032H17.1953L16.2846 18.7467C16.252 19.1724 16.0678 19.5694 15.7687 19.8585C15.4695 20.1476 15.0776 20.3074 14.6711 20.3061H9.72415C9.31896 20.3028 8.92942 20.1413 8.63123 19.8532C8.33303 19.565 8.14749 19.1706 8.11067 18.7467Z"
        fill="black"
      />
    </svg>
  );
};

export default Bin;
